/**
 * MoyasarPaymentForm
 *
 * Reusable component that renders the Moyasar JS SDK payment form.
 * Supports credit card and Apple Pay methods.
 * Uses the same pattern as GuestPortalCheckout.tsx.
 */

import { useEffect, useRef } from 'react';
import { IMoyasarPaymentFormProps } from '../../types';

// Extend Window interface for Moyasar
declare global {
  interface Window {
    Moyasar: any;
  }
}

const MoyasarPaymentForm = ({
  paymentConfig,
  callbackUrl,
  methods,
  language = 'en',
  onCompleted,
}: IMoyasarPaymentFormProps) => {
  const formContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (formContainer.current && window.Moyasar && paymentConfig) {
      // Clear previous form before re-initializing
      formContainer.current.innerHTML = '';

      window.Moyasar.init({
        element: formContainer.current,
        amount: Math.round(paymentConfig.amount * 100), // Convert to halalas (rounded to avoid floating point)
        currency: paymentConfig.currency,
        description: paymentConfig.transactionGuid,
        publishable_api_key: paymentConfig.publishableApiKey,
        callback_url: callbackUrl,
        language,
        supported_networks: ['visa', 'mastercard', 'mada'],
        methods,
        metadata: paymentConfig.metadata,
        apple_pay: {
          country: 'SA',
          label: 'Msool Subscription',
          validate_merchant_url: 'https://api.moyasar.com/v1/applepay/initiate',
        },
        credit_card: {
          save_card: paymentConfig.saveCard,
        },
        on_completed: async function (payment: any) {
          await onCompleted(payment);
        },
      });
    }
  }, [paymentConfig, callbackUrl, methods, language, onCompleted]);

  return <div className="mysr-form" ref={formContainer} />;
};

export default MoyasarPaymentForm;
